import * as React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { SubHeading, SubHeadingLevel } from '../../Typography/sub-heading';
import { jsx as _jsx } from "react/jsx-runtime";
export const SectionGroupHeading = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    styles: {
      root: {
        marginBottom: 5
      }
    },
    children: /*#__PURE__*/_jsx(SubHeading, {
      headingLevel: SubHeadingLevel.Level2,
      children: children
    })
  });
};